import { createContext, useContext } from 'react';
import { WorkspaceView } from '../../../types/WorkspaceView';

interface ViewContextProps {
  view: WorkspaceView | null;
  setView: (view: WorkspaceView) => void;
  views: WorkspaceView[];
  setViews: (views: WorkspaceView[]) => void;
  /**
   * True once the user changes this view's display config without saving it.
   * It can't be derived by comparing the active view to the saved one: a peer saving
   * the view makes them differ too, and the two cases need opposite handling — the
   * active view adopts a peer's change only when the local copy is untouched.
   */
  isViewDirty: boolean;
  setViewDirty: (dirty: boolean) => void;
}

export const ViewContext = createContext<ViewContextProps | undefined>(undefined);

export const useViewContext = () => {
  const context = useContext(ViewContext);
  return context;
};
